import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './Project-Grid.css';

export default function ProjectGrid({ projects }) {
  return (
    <div className="hdow-grid">
      {projects.map((p) => {
        const href = p.slug ? `/our-work/${p.slug}` : `/our-work/id/${p.id}`;
        const hasImg = typeof p.imageSrc === 'string' && p.imageSrc.trim().length > 0;
        return (
          <Link key={p.id} to={href} className="hdow-card hdow-card-link" aria-label={p.title}>
            <div className="hdow-card-media">
              {hasImg ? (
                <img src={p.imageSrc} alt={p.title} />
              ) : (
                <div className="hdow-card__placeholder">No image</div>
              )}
            </div>
            <div className="hdow-overlay">
              <span className="hdow-title-text">{p.title}</span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}

ProjectGrid.propTypes = {
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      slug: PropTypes.string,
      title: PropTypes.string.isRequired,
      imageSrc: PropTypes.string,
    })
  ).isRequired,
};
